
{
    "image": "Hero Carousel Image"
}
